import React from "react";
import { ArrowLeft, ArrowRight } from "@material-ui/icons";
import { Tab, Tabs } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { actions as resAct } from "../../../../ReservePage/_redux/reserveRedux";
import { actions } from "../../../../SearchPage/_redux/searchRedux";
import { search_travel } from "../../../../SearchPage/_redux/searchCrud";
import { useHistory } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import queryStringParse from "../../../../../../functions/queryParam";
import momentJalali from "moment-jalaali";
import moment from "moment";
export default (props) => {
  const [pageMultipe, setPageMultipe] = React.useState(0);
  const [countMultiple, setCountMultiple] = React.useState(5);

  let { state: resState } = useSelector((state) => ({
    state: state.reserve,
  }));

  const history = useHistory();
  const dispatch = useDispatch();
  // const searchedDate = history.location.pathname.split("/")[4];
  let params = [];

  if (history.location.search) {
    var search = history.location.search;
    params = queryStringParse(search);

  }
  const searchedDate = params.date;
  const isTabletOrMobile = useMediaQuery({ maxWidth: 991 });

  const handleTabsChange = (event, newValue) => {
    const newDate = new Date(newValue.replace(/-/g, "/")).setDate(
      new Date(newValue.replace(/-/g, "/")).getDate() + 1
    );

    if (new Date(newDate) > new Date()) {
      console.log("in if", newValue);

      dispatch(resAct.setTabsDate(newValue));
      dispatch(resAct.setLoadingStats(undefined));
      search_travel(props.props.source_id, props.props.dest_id, newValue)
        .then((res) => {
          dispatch(actions.loadTravels(res.data.data));
          dispatch(actions.setFilteredTravels(res.data.data));
          dispatch(resAct.setMockTravels(res.data.data));
          if (res.data.data.length === 0) {
            dispatch(resAct.setLoadingStats("0"));
          } else {
            dispatch(resAct.setLoadingStats("1"));
          }
        })
        .catch(() => {
          dispatch(resAct.setLoadingStats("-1"));
        });

      history.push(
        props.props.date2
          ? `/bus-ticket/${props.props.source_id ? props.props.source_id : null}/${props.props.dest_id ? props.props.dest_id : null
          }?date=${newValue},${props.props.date2}&count=${props.props.count ? props.props.count : null
          }`
          : `/bus-ticket/${props.props.source_id ? props.props.source_id : null}/${props.props.dest_id ? props.props.dest_id : null
          }?date=${newValue}&count=${props.props.count ? props.props.count : null}`
      );
    } else {
      console.log("in else", newValue);

      return false;
    }
  };

  const dateGenerator = (date, day) => {
    if (date) {

      // date.setDate(date.getDate() + day);
      if (isTabletOrMobile) {
        date = moment(date, 'YYYY/MM/DD').add(day, 'day').format('YYYY/MM/DD');
        const persianDate = momentJalali(date).format('jYYYY/jMM/jDD');
        // const persianDate = date.toLocaleDateString("fa-IR");
        return persianDate;
      } else if (!isTabletOrMobile) {
        date.setDate(date.getDate() + day);
        let dateOptions = {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        };

        const persianDate = date
          .toLocaleDateString("fa-IR", dateOptions)
          .split(" ");

        const clearedDay = persianDate[2].replace(",", "");

        return (
          <div className="d-block">
            <h4 className="my-3"> {persianDate[3]}</h4>
            <h4>{`${clearedDay} ${persianDate[1]}`}</h4>
          </div>
        );
      }
    }
  };

  const forbiddnReturner = (date, day) => {
    const newDate = new Date(date).setDate(new Date(date).getDate() + day);
    if (new Date(newDate) < new Date()) {
      return "not-allowed";
    } else {
      return "pointer";
    }
  };

  const dateValueGenerator = (date, day) => {
    let momentDate = moment(date).add(day, 'day').format('YYYY-MM-DD');

    // momentDate.add(day, 'day').format('YYYY-MM-DD');
    // momentDate.setDate(momentDate + day);
    // console.log("jaskjasdh",momentDate);
    // const splittedDate = date.toLocaleDateString().split("/");
    // const finalDate = `${splittedDate[2]}-${splittedDate[0]}-${splittedDate[1]}`;
    return momentDate;
  };

  React.useLayoutEffect(() => {
    dispatch(resAct.setTabsDate(dateValueGenerator(new Date(searchedDate), 0)));
    dateGenerator(new Date(searchedDate), 0);
    if (!resState.firstTabsDate) {
      dispatch(resAct.setFirstTabsDate(searchedDate));
    }
    // setValue(props.props.date);
  }, []);

  return (
    <>
      {isTabletOrMobile ? (
        <div className="responsive-div d-flex align-items-center flex-wrap">
          <div
            className="col-3 mobile-arrows-right d-flex justify-content-between align-items-center"
            onClick={() => {
              let tempDate = searchedDate.replace(/-/g, "/");

              if (new Date(tempDate) > new Date()) {
                const valDate = dateValueGenerator(new Date(tempDate), -1);
                handleTabsChange(null, valDate);
              } else {
                return false;
              }
            }}
            style={{
              color:
                new Date(searchedDate.replace(/-/g, "/")) > new Date()
                  ? "black"
                  : "darkgray",
            }}
          >
            <ArrowRight className="font-35" />
            <span className="font-16">روز قبل</span>
          </div>
          <div className="col-6 d-flex align-items-center justify-content-center font-16">
            { }
            {dateGenerator(new Date(searchedDate.replace(/-/g, "/")), 0)}
            {console.log(dateGenerator(new Date(searchedDate), 0))}
          </div>
          <div
            className="col-3 mobile-arrows-left d-flex justify-content-between align-items-center"
            onClick={() => {
              let tempDate = searchedDate.replace(/-/g, "/");
              let valDate = dateValueGenerator(new Date(tempDate), 1);
              handleTabsChange(null, valDate);
            }}
          >
            <span className="font-16">روز بعد</span>
            <ArrowLeft className="font-35" />
          </div>
        </div>
      ) : (
        <div
          className="w-100 bg-white d-flex align-items-center"
          style={{
            border: "1px solid darkgray",
            marginBottom: "35px",
            borderRadius: "13px",
          }}
        >
          <ArrowRight
            style={{ fontSize: 25 }}
            onClick={() => {
              setPageMultipe(+pageMultipe - 1);
            }}
          />
          <Tabs
            className="w-100"
            value={resState.tabsDate}
            onChange={handleTabsChange}
            aria-label="basic tabs example"
            style={{ justifyContent: "space-around" }}
          >
            <Tab
              className="d-block"
              value={dateValueGenerator(
                new Date(),
                0 + pageMultipe * +countMultiple
              )}
              label={dateGenerator(
                new Date(),
                0 + pageMultipe * +countMultiple
              )}
              style={{
                maxWidth: "20%",
                cursor: forbiddnReturner(
                  new Date(),
                  0 + pageMultipe * +countMultiple
                ),
              }}
            />
            <Tab
              className="d-block"
              value={dateValueGenerator(
                new Date(),
                1 + pageMultipe * +countMultiple
              )}
              label={dateGenerator(
                new Date(),
                1 + pageMultipe * +countMultiple
              )}
              style={{
                maxWidth: "20%",
                cursor: forbiddnReturner(
                  new Date(),
                  0 + pageMultipe * +countMultiple
                ),
              }}
            />
            <Tab
              className="d-block"
              value={dateValueGenerator(
                new Date(),
                2 + pageMultipe * +countMultiple
              )}
              label={dateGenerator(
                new Date(),
                2 + pageMultipe * +countMultiple
              )}
              style={{
                maxWidth: "20%",
                cursor: forbiddnReturner(
                  new Date(),
                  0 + pageMultipe * +countMultiple
                ),
              }}
            />
            <Tab
              className="d-none d-lg-block"
              label={dateGenerator(
                new Date(),
                3 + pageMultipe * +countMultiple
              )}
              value={dateValueGenerator(
                new Date(),
                3 + pageMultipe * +countMultiple
              )}
              style={{
                maxWidth: "20%",
                cursor: forbiddnReturner(
                  new Date(),
                  0 + pageMultipe * +countMultiple
                ),
              }}
            />
            <Tab
              className="d-none d-lg-block"
              label={dateGenerator(
                new Date(),
                4 + pageMultipe * +countMultiple
              )}
              value={dateValueGenerator(
                new Date(),
                4 + pageMultipe * +countMultiple
              )}
              style={{
                maxWidth: "20%",
                cursor: forbiddnReturner(
                  new Date(),
                  0 + pageMultipe * +countMultiple
                ),
              }}
            />
          </Tabs>
          <ArrowLeft
            style={{ fontSize: 25 }}
            onClick={() => {
              setPageMultipe(+pageMultipe + 1);
            }}
          />
        </div>
      )}
    </>
  );
};